import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import { INSURANCE_EVENTS_CORRELATION_QUERY } from "../queries";

export const useEventsCorrelation = () => {
  const client = useApolloClient();

  const retrieveCorrelations = useCallback(() => {
    const {
      insuranceEventsCorrelation: { correlations }
    } = client.readQuery({ query: INSURANCE_EVENTS_CORRELATION_QUERY });

    return correlations;
  }, [client]);

  const retrieveCorrelation = ({ correlationId, key }) => {
    const correlations = retrieveCorrelations();
    const correlation = key
      ? correlations.find(z => z.correlationId === correlationId && z.key === key)
      : correlations.find(z => z.correlationId === correlationId);
    return correlation;
  };

  const persistCorrelation = useCallback(
    correlation => {
      const correlations = retrieveCorrelations();

      //remove old correlations from cache
      const cleanCorrelations = correlation.key
        ? correlations.filter(z => z.name !== correlation.name && z.key !== correlation.key)
        : correlations.filter(z => z.name !== correlation.name);

      client.writeQuery({
        query: INSURANCE_EVENTS_CORRELATION_QUERY,
        data: {
          insuranceEventsCorrelation: {
            __typename: "insuranceEventsCorrelation",
            correlations: [...cleanCorrelations, correlation]
          }
        }
      });
    },
    [client, retrieveCorrelations]
  );

  const persistCorrelations = useCallback(
    correlations => {
      client.writeQuery({
        query: INSURANCE_EVENTS_CORRELATION_QUERY,
        data: {
          insuranceEventsCorrelation: {
            __typename: "insuranceEventsCorrelation",
            correlations
          }
        }
      });
    },
    [client]
  );

  const evictCorrelation = correlationId => {
    const correlations = [...retrieveCorrelations()];
    const correlation = correlations.find(z => z.correlationId === correlationId);
    const index = correlations.indexOf(correlation);

    if (index > -1) {
      correlations.splice(index, 1);
      persistCorrelations(correlations);
    }
  };

  return { retrieveCorrelation, persistCorrelation, evictCorrelation };
};
